var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1895 42.3242V51.9902H55.0252V42.3242",
    stroke: "black",
    strokeWidth: 4.45605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8691 23.0352C29.8691 19.0311 33.1151 15.7852 37.1191 15.7852V15.7852C41.1232 15.7852 44.3691 19.0311 44.3691 23.0352V23.2177H29.8691V23.0352Z",
    stroke: "black",
    strokeWidth: 4.45605,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2129 41.7187V14.8749C20.2129 10.5883 23.6879 7.11328 27.9746 7.11328H30.1219C33.9864 7.11328 37.1191 10.2461 37.1191 14.1106V14.1106",
    stroke: "black",
    strokeWidth: 4.45605,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6465 42.3633C67.6465 41.1328 66.6489 40.1353 65.4184 40.1353C64.1879 40.1353 63.1904 41.1328 63.1904 42.3633H67.6465ZM63.8925 60.1886L61.9073 59.1771L63.8925 60.1886ZM57.7743 66.3069L58.7858 68.292L57.7743 66.3069ZM63.1904 42.3633V45.4328H67.6465V42.3633H63.1904ZM43.0184 65.6047H31.2184V70.0608H43.0184V65.6047ZM11.0464 45.4328V42.3633H6.59034V45.4328H11.0464ZM31.2184 65.6047C27.2612 65.6047 24.4274 65.603 22.2046 65.4214C20.0079 65.2419 18.6049 64.8979 17.474 64.3217L15.451 68.292C17.3148 69.2417 19.3694 69.6607 21.8418 69.8627C24.2881 70.0625 27.3348 70.0608 31.2184 70.0608V65.6047ZM6.59034 45.4328C6.59034 49.3164 6.5886 52.3631 6.78847 54.8094C6.99047 57.2817 7.40942 59.3363 8.35909 61.2001L12.3295 59.1771C11.7532 58.0462 11.4092 56.6433 11.2297 54.4465C11.0481 52.2238 11.0464 49.3899 11.0464 45.4328H6.59034ZM17.474 64.3217C15.259 63.1931 13.4581 61.3922 12.3295 59.1771L8.35909 61.2001C9.91492 64.2536 12.3975 66.7362 15.451 68.292L17.474 64.3217ZM63.1904 45.4328C63.1904 49.3899 63.1887 52.2238 63.0071 54.4465C62.8276 56.6433 62.4836 58.0462 61.9073 59.1771L65.8777 61.2001C66.8274 59.3363 67.2463 57.2817 67.4483 54.8094C67.6482 52.3631 67.6465 49.3164 67.6465 45.4328H63.1904ZM43.0184 70.0608C46.902 70.0608 49.9487 70.0625 52.395 69.8627C54.8674 69.6607 56.922 69.2417 58.7858 68.292L56.7628 64.3217C55.6319 64.8979 54.2289 65.2419 52.0322 65.4214C49.8094 65.603 46.9756 65.6047 43.0184 65.6047V70.0608ZM61.9073 59.1771C60.7787 61.3922 58.9778 63.1931 56.7628 64.3217L58.7858 68.292C61.8393 66.7362 64.3219 64.2536 65.8777 61.2001L61.9073 59.1771Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94727 42.3633L55.0256 42.3633",
    stroke: "black",
    strokeWidth: 4.45605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.418 42.3633H68.9141",
    stroke: "black",
    strokeWidth: 4.45605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.aad2ce3896e6649720648586b91bc0ea.svg";
export { ForwardRef as ReactComponent };